import TravelExploreOutlinedIcon from '@mui/icons-material/TravelExploreOutlined';
import DirectionsBoatOutlinedIcon from '@mui/icons-material/DirectionsBoatOutlined';
import MuseumOutlinedIcon from '@mui/icons-material/MuseumOutlined';
import BeachAccessOutlinedIcon from '@mui/icons-material/BeachAccessOutlined';
import type { ModuleDefinition } from '../../app/moduleRegistry';
import { isFeatureEnabled } from '../../config/featureFlags';
import { TourIframePage } from './TourIframePage';

const isVisible = () => isFeatureEnabled('HasTourIframe');

/** Legacy "Turlar" — 4 iframe screens, feature-flagged (`HasTourIframe`, off by default). */
export const toursModule: ModuleDefinition = {
  routes: [
    { path: 'tours/international', element: <TourIframePage kind="international" title="Yurt Dışı Turları" />, requiresRole: isVisible },
    { path: 'tours/cruise', element: <TourIframePage kind="cruise" title="Gemi Turları" />, requiresRole: isVisible },
    { path: 'tours/cultural', element: <TourIframePage kind="cultural" title="Kültür Turları" />, requiresRole: isVisible },
    { path: 'tours/cyprus', element: <TourIframePage kind="cyprus" title="Kıbrıs Otelleri" />, requiresRole: isVisible },
  ],
  menuItems: [
    { label: 'Yurt Dışı Turları', path: 'tours/international', icon: <TravelExploreOutlinedIcon />, group: 'Turlar', groupIcon: <TravelExploreOutlinedIcon />, isVisible },
    { label: 'Gemi Turları', path: 'tours/cruise', icon: <DirectionsBoatOutlinedIcon />, group: 'Turlar', isVisible },
    { label: 'Kültür Turları', path: 'tours/cultural', icon: <MuseumOutlinedIcon />, group: 'Turlar', isVisible },
    { label: 'Kıbrıs Otelleri', path: 'tours/cyprus', icon: <BeachAccessOutlinedIcon />, group: 'Turlar', isVisible },
  ],
};
